export default __webpack_public_path__ + "static/media/cello-game-page.bc31ddd5.png";